import _ from 'lodash'
import {createContext, FC, useContext, useState} from 'react'

type SolutionCenterContextType = {
  isActive: boolean
  setIsActive: (isActive: boolean) => void
}

const SolutionCenterContext = createContext<SolutionCenterContextType>({
  isActive: false,
  setIsActive: _.identity,
})

export const useSolutionCenterContext = (): SolutionCenterContextType =>
  useContext(SolutionCenterContext)

export const SolutionCenterProvider: FC<React.PropsWithChildren<unknown>> = ({children}) => {
  const [isActive, setIsActive] = useState(false)

  return (
    <SolutionCenterContext.Provider value={{isActive, setIsActive}}>
      {children}
    </SolutionCenterContext.Provider>
  )
}
